"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const pulse_components_1 = require("@pcs/pulse-components");
const clsx_1 = __importDefault(require("clsx"));
const utilities_1 = __importDefault(require("jsAssets/utilities"));
const helper_1 = require("../../helper");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const CONTENT = (helper_1.REQUEST === null || helper_1.REQUEST === void 0 ? void 0 : helper_1.REQUEST.content) || '';
const GenPublicLinkModalWrapper = ({ children, roundId }) => {
    const [value, setValue] = react_1.default.useState('');
    const [isOpen, setIsOpen] = react_1.default.useState(false);
    const caNotCopy = !value;
    const handleOpen = () => {
        const { state } = window.history;
        const finalRoundId = CONTENT === 'passport-reviews' ? state === null || state === void 0 ? void 0 : state.roundId : roundId;
        utilities_1.default.blockPage('Generate public link....');
        pulse_components_1.v2Endpoint
            .get(`${helper_1.URLS.app}api/rounds/${finalRoundId || roundId}/public-link`)
            .then(({ data }) => {
            var _a;
            const publicLink = (_a = data === null || data === void 0 ? void 0 : data.meta) === null || _a === void 0 ? void 0 : _a.public_link;
            setValue(publicLink);
            setIsOpen(true);
        })
            .catch((error) => {
            var _a, _b, _c;
            setIsOpen(false);
            const message = (_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : 'Somethings wrong when generate public link';
            utilities_1.default.notification.danger(message);
        })
            .finally(() => {
            utilities_1.default.unblockPage();
        });
    };
    const handleClose = () => {
        setIsOpen(false);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(pulse_components_1.PulseModalBase, { isV3: true, open: isOpen, onModalClose: handleClose, headerPrimaryText: 'REVIEW ROUND:  PUBLIC LINK', classes: {
                root: [styles_modules_less_1.default['public-link-modal__body']],
                dialog: {
                    paper: styles_modules_less_1.default['public-link-modal__root'],
                },
                footer: {
                    confirm: ['confirm-move-btn'],
                },
            }, PulseModalHeaderProps: {
                isV3: true,
                classes: {
                    root: styles_modules_less_1.default['public-link-modal-header__root'],
                    titleContainer: styles_modules_less_1.default['public-link-modal-header__ctn'],
                    titlePrimary: styles_modules_less_1.default['public-link-modal-header__title'],
                    closeBtn: styles_modules_less_1.default['public-link-modal-header__closeBtn'],
                },
                headerIconClasses: (0, clsx_1.default)(styles_modules_less_1.default['public-link-modal-header__icon']),
            }, variant: "jqconfirm", footerConfirmComponent: react_1.default.createElement(react_1.default.Fragment, null) },
            react_1.default.createElement("div", { className: (0, clsx_1.default)(styles_modules_less_1.default['public-link-modal-content__root']), "data-testid": "public-link-modal" },
                react_1.default.createElement("div", { className: styles_modules_less_1.default['public-link-project-select'] },
                    react_1.default.createElement("span", { className: styles_modules_less_1.default['public-link-modal__secondary-text'] }, "This public link allow access for any user assigned to this Review round, as identified by their email address."),
                    react_1.default.createElement("div", { className: styles_modules_less_1.default['public-link-modal__actions'] },
                        react_1.default.createElement(pulse_components_1.PulseInput, { classes: {
                                root: styles_modules_less_1.default['public-link-modal-action__input'],
                            }, label: "", InputBaseProps: {
                                value,
                                disabled: true,
                                inputProps: {
                                    'data-testid': 'public-link-input',
                                },
                            } }),
                        react_1.default.createElement(pulse_components_1.PulseButtonV3, { disabled: caNotCopy, onClick: () => {
                                var _a;
                                (_a = navigator === null || navigator === void 0 ? void 0 : navigator.clipboard) === null || _a === void 0 ? void 0 : _a.writeText(value).then(() => {
                                    utilities_1.default.dismissNotifications();
                                    utilities_1.default.notify({
                                        message: 'Copied Public Link to clipboard',
                                        status: 'success',
                                        timeout: 4000,
                                        pos: 'top-center',
                                    });
                                }).catch(() => {
                                    utilities_1.default.notification.danger('Something went wrong');
                                });
                            }, icon: true, iconClasses: {
                                icon: 'fa-solid fa-copy',
                            }, label: 'Copy Public Link', variant: pulse_components_1.V3ButtonVariant.tertiary, "data-action": "copy" }))))),
        children({
            handleOpenPublicLinkModal: handleOpen,
        })));
};
exports.default = GenPublicLinkModalWrapper;
